import React from "react";
import styled from "styled-components";

import PageSection from "../../elements/PageSection";
import KpiMetric from "./KpiMetric";
import PeriodMetric from "./PeriodMetric";
import NewIdeasMetric from "./NewIdeasMetric";
import CompanyRankMetric from "./CompanyRankMetric";
import {borderColour, pageHeaderBackgroundColour, subduedTextColour} from "../../../style/styleConsts";
import PageHeading from "../../elements/PageHeading";
import {Clock, LocalDate} from "js-joda";
import LoggingLink from "../../elements/LoggingLink";
import {Controls} from "./Controls";
import {asLocalTime} from "../../../util/timeDescription";
import {useSelector} from "react-redux";

const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 3px;
`;

export const PortfolioIdentity = styled.div`
    margin-right: 20px;
`;

const Metrics = styled.div`
    display: flex;
    flex-direction: row;
`;

export const PortfolioName = styled(PageHeading)``;

export const CompanyName = styled(PageHeading)``;

export const CompanyIdentity = styled(PortfolioIdentity)`
    border-left: 1px solid ${borderColour};
    padding-left: 20px;
`;

export const PortfolioHeader = styled.div`
    color: ${subduedTextColour};
    margin-right: 10px;
`;

export const PortfolioOwnerName = styled(PortfolioHeader)``;

export const AllAuthors = styled(PortfolioHeader)``;

const Title = styled.div`
    display: flex;
`;

const PortfolioSubtitle = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledLoggingLink = styled(LoggingLink)`
    color: inherit;
`;

const PerformanceInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

const PortfolioPerformanceTimestamp = styled.div`
    margin-left: 30px;
    color: #b6b6b6;
    font-size: 10px;
    text-align: right;
`;

export const WholePortfolioLink = ({path, id, name, children}) => (
    <StyledLoggingLink
        to={path}
        loggingPayload={{type: `SEE_WHOLE_PORTFOLIO_CLICKED`, portfolioId: id, portfolioName: name}}
        className="t-portfolio-health-link">
        {children}
    </StyledLoggingLink>
);

export const PortfolioHeaderPageSection = styled(PageSection)`
    padding: 12px 30px 30px 30px;
    background-color: ${pageHeaderBackgroundColour};
`;

const OurProgrammePortfolioHeader = ({
                                         performancePeriod, periodStart, kpiValue, kpiName, currency, portfolioName, portfolioId, ownerName, showCompanyName = false,
                                         companyName, showCompanyRank, companyRank, totalCompanies, numberOfNewIdeas, periods, ourProgrammeContext, generatedAt
                                     }) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());
    const viewingOnDate = LocalDate.now(clock);
    const performancePeriodStart = periodStart ? LocalDate.parse(periodStart) : null;
    const rewardStartDate = LocalDate.parse(ourProgrammeContext.selectedPeriod.startDate);

    return (
        <div>
            <Controls periods={periods} ourProgrammeContext={ourProgrammeContext} viewingOnDate={viewingOnDate}/>
            <PortfolioHeaderPageSection>
                <Header>
                    <Title>
                        <PortfolioIdentity>
                            <PortfolioName>{portfolioName}</PortfolioName>
                            <PortfolioSubtitle>
                                <PortfolioOwnerName>{ownerName}</PortfolioOwnerName>
                                {showCompanyName ?
                                    <WholePortfolioLink id={portfolioId} name={portfolioName}
                                                        path={ourProgrammeContext.wholePortfolioPath()}>
                                        See whole portfolio
                                    </WholePortfolioLink>
                                    : null}
                            </PortfolioSubtitle>
                        </PortfolioIdentity>

                        {showCompanyName ?
                            <CompanyIdentity>
                                <CompanyName className="t-portfolio-header-company-name">{companyName}</CompanyName>
                                <AllAuthors>All Authors</AllAuthors>
                            </CompanyIdentity>
                            : null}
                    </Title>
                    <PerformanceInfo>
                        <Metrics>
                            <PeriodMetric performancePeriodBasis={performancePeriod}
                                          periodStartDate={performancePeriodStart}
                                          rewardStartDate={rewardStartDate} viewingOnDate={viewingOnDate}/>
                            {showCompanyRank ? <CompanyRankMetric companyRank={companyRank}
                                                                  totalCompanyCount={totalCompanies}/> : null}
                            <NewIdeasMetric numberOfNewIdeas={numberOfNewIdeas}/>
                            <KpiMetric kpiName={kpiName} kpiValue={kpiValue} currency={currency}/>
                        </Metrics>
                        {generatedAt ? <PortfolioPerformanceTimestamp className="t-portfolio-performance-timestamp">
                            as at {asLocalTime(generatedAt, clock)}
                        </PortfolioPerformanceTimestamp> : null}
                    </PerformanceInfo>
                </Header>
            </PortfolioHeaderPageSection>
        </div>
    );
};

export default OurProgrammePortfolioHeader;
